import { render, staticRenderFns } from "./KitDelete.vue?vue&type=template&id=649469c8"
import script from "./KitDelete.vue?vue&type=script&lang=js"
export * from "./KitDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports